import React, { useEffect, useRef } from 'react'

function AppScreenshots() {
  const screenshotRefs = useRef([])

  useEffect(() => {
    const observers = screenshotRefs.current.map((ref) => {
      if (!ref) return null
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible')
            }
          })
        },
        { threshold: 0.1 }
      )
      
      observer.observe(ref)
      return observer
    })

    return () => {
      observers.forEach((observer) => observer?.disconnect())
    }
  }, [])

  const screenshots = [
    {
      image: '/splashscreenapp.jpeg',
      title: 'Splash Screen',
      description: 'Willkommen bei spotx – dein Einstieg in die App'
    },
    {
      image: '/homescreenapp.jpeg',
      title: 'Home Screen',
      description: 'Übersicht deiner Kampagnen und Belohnungen auf einen Blick'
    },
    {
      image: '/interessenapp.jpeg',
      title: 'Interessen',
      description: 'Wähle deine Interessen für passende und relevante Kampagnen'
    },
    {
      image: '/benachrichtigungapp.jpeg',
      title: 'Benachrichtigungen',
      description: 'Verwalte deine Benachrichtigungen für optimale Erinnerungen'
    },
    {
      image: '/einstellungenapp.jpeg',
      title: 'Einstellungen',
      description: 'Passe die App nach deinen persönlichen Wünschen an'
    }
  ]

  return (
    <section id="screenshots" className="screenshots section">
      <div className="container">
        <h2 className="section-title">Die spotx App</h2>
        <p className="section-subtitle">
          Moderne, intuitive Oberfläche für iOS und Android – optimiert für beste Nutzererfahrung
        </p>
        <div className="screenshots-grid">
          {screenshots.map((screenshot, index) => (
            <div
              key={index}
              className="screenshot-card"
              ref={(el) => (screenshotRefs.current[index] = el)}
            >
              <div className="screenshot-image-wrapper">
                <img 
                  src={screenshot.image} 
                  alt={screenshot.title}
                  className="screenshot-image"
                  loading="lazy"
                />
              </div>
              <div className="screenshot-info">
                <h3 className="screenshot-title">{screenshot.title}</h3>
                <p className="screenshot-description">{screenshot.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AppScreenshots
